import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar2 from "../../navbar/Navbar2";
import Axios from "../../Axios";
import { AuthContext } from "../../AuthProvider";
import { HomePageContext } from "../../HomepageProvider";
import BottomNavbar from "../../components/bottomNavbar/BottomNavbar";
import "./CampignMgmtPage.css";

// Shadcn UI components
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Card, CardContent, CardFooter, CardHeader } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../components/ui/dropdown-menu";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../../components/ui/alert-dialog";
import { ArrowLeft, Calendar, Filter, BarChart, Search, Trash2, PlusCircle, Edit, Play, Pause, AlertTriangle } from "lucide-react";

// Tab options
const tabs = ["All", "Active", "Completed", "Draft"];

export default function CampignMgmtPage({ text, filterAdOverOtherCamp }) {
  const { campaignMgnPage } = useContext(HomePageContext);
  const [choseTab, setChoseTab] = useState("All");
  const { userToken, fbToken, allFbData } = useContext(AuthContext);
  const [draftUserData, setDraftUserData] = useState([]);
  const [filterCompleted, setFilterCompleted] = useState([]);
  const navigate = useNavigate();
  const [allCamapignData, setAllCamapignData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterActive, setFilterActive] = useState([]);
  const [filteredDraftUserData, setFilteredDraftUserData] = useState([]);
  const [filteredCompleteAndLiveData, setFilteredCompleteAndLiveCardData] = useState([]);
  const [underRiview, setUnderRiview] = useState([]);
  const [activeUnderReviewData, setActiveUnderReviewData] = useState([]);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [selectedDraftId, setSelectedDraftId] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const formatName = (name) => {
    if (!name) return '';
    let trimmedName = name.replace(/\d+$/, '').replace(/_+$/, '');
    trimmedName = trimmedName.replace(/_/g, ' ').trim();
    return trimmedName.replace(/\s+/g, ' ');
  };

  const CampMgnFilterData = (data) => {
    let campigncard = [];
    if (data) {
      data?.forEach((val) => {
        const obj1 = {
          campaign_id: val?.id,
          name: val?.name ? val?.name : '',
          lifetime_budget: val?.lifetime_budget ? (Number(val?.lifetime_budget)) : 0,
          status: val?.status,
          impressions: 0,
          spend: 0,
          leads_count: 0,
          _id: val?.dbId,
          discount: val?.discount,
          date: val?.createdAt,
        };

        val?.insights?.data?.forEach((val) => {
          obj1.leads_count =
            obj1?.leads_count +
            (parseInt(val?.actions?.length ? val?.actions?.find((action) => action?.action_type === 'lead')?.value || 0 : 0));

          obj1.impressions = obj1.impressions + (val?.impressions ? Number(val?.impressions) : 0);
          obj1.spend = obj1.spend + (val?.spend ? Number(val?.spend) : 0);
          obj1.cpm = obj1.cpm + (val?.cpm ? Number(val?.cpm) : 0);
          obj1.cpc = obj1.cpc + (val?.cpc ? Number(val?.cpc) : 0);
          obj1.ctr = obj1.ctr + (val?.ctr ? Number(val?.ctr) : 0);
        });

        if (obj1?.name) {
          campigncard?.push(obj1);
        }
      });
    }

    if (campigncard.length) {
      setAllCamapignData(campigncard?.reverse());

      const flterCompleted = campigncard?.filter((val) => {
        return val.status === "STOPPED" || val.status === "COMPLETED";
      });
      
      if (flterCompleted) {
        setFilterCompleted(flterCompleted);
      }

      const flterActive = campigncard?.filter((val) => {
        return val.status === "ACTIVE" || val.status === "PAUSED" || val.status === "UNDER REVIEW";
      });
      
      if (flterActive) {
        setFilterActive(flterActive);
      }
    }
  };

  useEffect(() => {
    CampMgnFilterData(allFbData);
  }, [allFbData?.length]);

  // For draft campaigns
  const draftUserDataApi = async () => {
    try {
      const response = await Axios.get("/get-properties", {
        headers: {
          Authorization: userToken,
        },
      });
      
      if (response.data.valid) {
        setDraftUserData(response.data.message);
      } else {
        console.log("API valid field is false");
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    draftUserDataApi();
  }, []);

  const handleUnderRiview = async () => {
    try {
      const res = await Axios.get("/get-under-review", {
        headers: {
          Authorization: userToken
        }
      });
      
      if (res.status === 200) {
        let underreview = [];
        const data = res?.data?.message;

        data.forEach((val) => {
          const obj1 = {
            campaign_id: val?.campaign_id,
            name: val?.name,
            lifetime_budget: Number(val.lifetime_budget),
            status: val?.status,
            impressions: 0,
            spend: 0,
            leads_count: 0,
            _id: val?._id,
            discount: Number(val?.discount) ? Number(val?.discount) : 30
          };
          
          if (obj1) {
            underreview.unshift(obj1);
          }
        });
        
        if (underreview.length > 0) {
          setUnderRiview(underreview);
        }
      }
    } catch (error) {
      console.error("Error fetching under review campaigns:", error);
    }
  };

  useEffect(() => {
    handleUnderRiview();
  }, []);

  const handleDeleteDraft = async (id) => {
    setIsDeleting(true);
    try {
      const response = await Axios.delete(`/delete-property/${id}`, {
        headers: {
          Authorization: userToken,
        },
      });
      
      if (response.data.valid) {
        setDraftUserData(prevData => prevData.filter(item => item._id !== id));
      }
    } catch (error) {
      console.error("Error deleting draft:", error);
    } finally {
      setIsDeleting(false);
      setIsDeleteDialogOpen(false);
    }
  };

  const confirmDelete = (id) => {
    setSelectedDraftId(id);
    setIsDeleteDialogOpen(true);
  };

  // Search filters
  const SearchfilterData = () => {
    return filterActive?.filter(item =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const SearchfilterDataCompleted = () => {
    return filterCompleted?.filter(item =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const SearchfilterAllData = () => {
    return allCamapignData?.filter(item =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const SearchfilterDataDraft = () => {
    return draftUserData?.filter(item => 
      item.name && item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  // Sort functions
  const onFilterByLead = () => {
    setAllCamapignData(prev => [...prev].sort((a, b) => b.leads_count - a.leads_count));
    setFilterActive(prev => [...prev].sort((a, b) => b.leads_count - a.leads_count));
    setFilterCompleted(prev => [...prev].sort((a, b) => b.leads_count - a.leads_count));
  };

  const onFilterBySpent = () => {
    setAllCamapignData(prev => [...prev].sort((a, b) => b.spend - a.spend));
    setFilterActive(prev => [...prev].sort((a, b) => b.spend - a.spend));
    setFilterCompleted(prev => [...prev].sort((a, b) => b.spend - a.spend));
  };

  const onFilterByDate = () => {
    const sortByDate = (a, b) => new Date(b?.date) - new Date(a?.date);
    setAllCamapignData(prev => [...prev].sort(sortByDate));
    setFilterActive(prev => [...prev].sort(sortByDate));
    setFilterCompleted(prev => [...prev].sort(sortByDate));
    setDraftUserData(prev => [...prev].sort(sortByDate));
  };

  // Get status badge variant
  const getStatusBadgeVariant = (status) => {
    switch(status) {
      case 'ACTIVE':
        return "success";
      case 'PAUSED':
        return "warning";
      case 'UNDER REVIEW':
        return "outline";
      case 'COMPLETED':
      case 'STOPPED':
        return "secondary";
      default:
        return "outline";
    }
  };

  // Format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount);
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).format(date);
  };

  return (
    <div className="bg-background min-h-screen flex flex-col">
      <Navbar2 />
      
      <main className="flex-1 container mx-auto px-4 py-6">
        <div className="flex items-center mb-6">
          <Button 
            variant="ghost" 
            size="icon" 
            className="mr-2" 
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-2xl font-bold">Campaign Management</h1>
        </div>
        
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
          <div className="relative w-full md:w-auto md:flex-1 max-w-md">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
            <Input
              className="pl-10"
              type="text"
              placeholder="Search campaigns..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          
          <div className="flex flex-wrap items-center gap-2">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline">
                  <Filter className="h-4 w-4 mr-2" />
                  Sort
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem onClick={onFilterByDate}>
                  Sort by date
                </DropdownMenuItem>
                <DropdownMenuItem onClick={onFilterByLead}>
                  Sort by leads
                </DropdownMenuItem>
                <DropdownMenuItem onClick={onFilterBySpent}>
                  Sort by spend
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
            
            <Button onClick={() => navigate("/property-details")}>
              <PlusCircle className="h-4 w-4 mr-2" />
              Create Campaign
            </Button>
          </div>
        </div>
        
        <Tabs defaultValue="All" className="w-full" onValueChange={setChoseTab}>
          <TabsList className="grid grid-cols-4 mb-6">
            {tabs.map((tab) => (
              <TabsTrigger key={tab} value={tab}>{tab}</TabsTrigger>
            ))}
          </TabsList>
          
          <TabsContent value="All" className="mt-0">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {SearchfilterAllData()?.map((campaign, index) => (
                <Card key={index} className="overflow-hidden">
                  <CardHeader className="p-4 pb-2">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="font-semibold text-lg leading-tight truncate max-w-[200px]" title={campaign.name}>
                          {formatName(campaign.name)}
                        </h3>
                        <p className="text-xs text-muted-foreground">{formatDate(campaign.date)}</p>
                      </div>
                      <Badge variant={getStatusBadgeVariant(campaign.status)}>
                        {campaign.status}
                      </Badge>
                    </div>
                  </CardHeader>
                  
                  <CardContent className="p-4 pt-2">
                    <div className="grid grid-cols-2 gap-4 mb-3">
                      <div>
                        <p className="text-xs text-muted-foreground">Budget</p>
                        <p className="font-medium">{formatCurrency(campaign.lifetime_budget)}</p>
                      </div>
                      <div>
                        <p className="text-xs text-muted-foreground">Spent</p>
                        <p className="font-medium">{formatCurrency(campaign.spend)}</p>
                      </div>
                      <div>
                        <p className="text-xs text-muted-foreground">Leads</p>
                        <p className="font-medium">{campaign.leads_count}</p>
                      </div>
                      <div>
                        <p className="text-xs text-muted-foreground">Impressions</p>
                        <p className="font-medium">{campaign.impressions.toLocaleString()}</p>
                      </div>
                    </div>
                  </CardContent>
                  
                  <CardFooter className="p-4 pt-0 flex justify-between">
                    <Button 
                      variant="outline" 
                      size="sm"
                      onClick={() => navigate("/leads", { state: campaign?.campaign_id })}
                    >
                      View Leads
                    </Button>
                    
                    <Button 
                      variant="outline" 
                      size="sm"
                      onClick={() => navigate("/campaign-overview", {
                        state: {
                          campaign_id: campaign?._id,
                          cmpid: campaign?.campaign_id
                        }
                      })}
                    >
                      Details
                    </Button>
                  </CardFooter>
                </Card>
              ))}
              
              {SearchfilterAllData()?.length === 0 && (
                <div className="col-span-full text-center py-12">
                  <p className="text-muted-foreground">No campaigns found</p>
                </div>
              )}
            </div>
          </TabsContent>
          
          <TabsContent value="Active" className="mt-0">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {SearchfilterData()?.map((campaign, index) => (
                <Card key={index} className="overflow-hidden">
                  <CardHeader className="p-4 pb-2">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="font-semibold text-lg leading-tight truncate max-w-[200px]" title={campaign.name}>
                          {formatName(campaign.name)}
                        </h3>
                        <p className="text-xs text-muted-foreground">{formatDate(campaign.date)}</p>
                      </div>
                      <Badge variant={getStatusBadgeVariant(campaign.status)}>
                        {campaign.status}
                      </Badge>
                    </div>
                  </CardHeader>
                  
                  <CardContent className="p-4 pt-2">
                    <div className="grid grid-cols-2 gap-4 mb-3">
                      <div>
                        <p className="text-xs text-muted-foreground">Budget</p>
                        <p className="font-medium">{formatCurrency(campaign.lifetime_budget)}</p>
                      </div>
                      <div>
                        <p className="text-xs text-muted-foreground">Spent</p>
                        <p className="font-medium">{formatCurrency(campaign.spend)}</p>
                      </div>
                      <div>
                        <p className="text-xs text-muted-foreground">Leads</p>
                        <p className="font-medium">{campaign.leads_count}</p>
                      </div>
                      <div>
                        <p className="text-xs text-muted-foreground">Impressions</p>
                        <p className="font-medium">{campaign.impressions.toLocaleString()}</p>
                      </div>
                    </div>
                  </CardContent>
                  
                  <CardFooter className="p-4 pt-0 flex justify-between">
                    <Button 
                      variant="outline" 
                      size="sm"
                      onClick={() => navigate("/leads", { state: campaign?.campaign_id })}
                    >
                      View Leads
                    </Button>
                    
                    <Button 
                      variant="outline" 
                      size="sm"
                      onClick={() => navigate("/campaign-overview", {
                        state: {
                          campaign_id: campaign?._id,
                          cmpid: campaign?.campaign_id
                        }
                      })}
                    >
                      Details
                    </Button>
                  </CardFooter>
                </Card>
              ))}
              
              {SearchfilterData()?.length === 0 && (
                <div className="col-span-full text-center py-12">
                  <p className="text-muted-foreground">No active campaigns found</p>
                </div>
              )}
            </div>
          </TabsContent>
          
          <TabsContent value="Completed" className="mt-0">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {SearchfilterDataCompleted()?.map((campaign, index) => (
                <Card key={index} className="overflow-hidden">
                  <CardHeader className="p-4 pb-2">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="font-semibold text-lg leading-tight truncate max-w-[200px]" title={campaign.name}>
                          {formatName(campaign.name)}
                        </h3>
                        <p className="text-xs text-muted-foreground">{formatDate(campaign.date)}</p>
                      </div>
                      <Badge variant={getStatusBadgeVariant(campaign.status)}>
                        {campaign.status}
                      </Badge>
                    </div>
                  </CardHeader>
                  
                  <CardContent className="p-4 pt-2">
                    <div className="grid grid-cols-2 gap-4 mb-3">
                      <div>
                        <p className="text-xs text-muted-foreground">Budget</p>
                        <p className="font-medium">{formatCurrency(campaign.lifetime_budget)}</p>
                      </div>
                      <div>
                        <p className="text-xs text-muted-foreground">Spent</p>
                        <p className="font-medium">{formatCurrency(campaign.spend)}</p>
                      </div>
                      <div>
                        <p className="text-xs text-muted-foreground">Leads</p>
                        <p className="font-medium">{campaign.leads_count}</p>
                      </div>
                      <div>
                        <p className="text-xs text-muted-foreground">Impressions</p>
                        <p className="font-medium">{campaign.impressions.toLocaleString()}</p>
                      </div>
                    </div>
                  </CardContent>
                  
                  <CardFooter className="p-4 pt-0 flex justify-between">
                    <Button 
                      variant="outline" 
                      size="sm"
                      onClick={() => navigate("/leads", { state: campaign?.campaign_id })}
                    >
                      View Leads
                    </Button>
                    
                    <Button 
                      variant="outline" 
                      size="sm"
                      onClick={() => navigate("/campaign-overview", {
                        state: {
                          campaign_id: campaign?._id,
                          cmpid: campaign?.campaign_id
                        }
                      })}
                    >
                      Details
                    </Button>
                  </CardFooter>
                </Card>
              ))}
              
              {SearchfilterDataCompleted()?.length === 0 && (
                <div className="col-span-full text-center py-12">
                  <p className="text-muted-foreground">No completed campaigns found</p>
                </div>
              )}
            </div>
          </TabsContent>
          
          <TabsContent value="Draft" className="mt-0">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {SearchfilterDataDraft()?.map((draft, index) => (
                <Card key={index} className="overflow-hidden">
                  <CardHeader className="p-4 pb-2">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="font-semibold text-lg leading-tight truncate max-w-[200px]" title={draft.name}>
                          {draft.name || "Untitled Draft"}
                        </h3>
                        <p className="text-xs text-muted-foreground">{formatDate(draft.createdAt)}</p>
                      </div>
                      <Badge variant="outline">
                        Draft
                      </Badge>
                    </div>
                  </CardHeader>
                  
                  <CardContent className="p-4 pt-2">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-xs text-muted-foreground">Type</p>
                        <p className="font-medium">{draft.propertyType || "Not specified"}</p>
                      </div>
                      <div>
                        <p className="text-xs text-muted-foreground">Location</p>
                        <p className="font-medium truncate max-w-[150px]" title={draft.location}>
                          {draft.location || "Not specified"}
                        </p>
                      </div>
                    </div>
                  </CardContent>
                  
                  <CardFooter className="p-4 pt-0 flex justify-between">
                    <Button 
                      variant="outline" 
                      size="sm"
                      onClick={() => confirmDelete(draft._id)}
                    >
                      <Trash2 className="h-4 w-4 mr-2" />
                      Delete
                    </Button>
                    
                    <Button 
                      onClick={() => navigate(`/property-details/${draft?._id}`)}
                    >
                      <Edit className="h-4 w-4 mr-2" />
                      Continue
                    </Button>
                  </CardFooter>
                </Card>
              ))}
              
              {SearchfilterDataDraft()?.length === 0 && (
                <div className="col-span-full text-center py-12">
                  <p className="text-muted-foreground">No draft campaigns found</p>
                </div>
              )}
            </div>
          </TabsContent>
        </Tabs>
      </main>
      
      <BottomNavbar />
      
      <AlertDialog open={isDeleteDialogOpen} onOpenChange={setIsDeleteDialogOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Are you sure?</AlertDialogTitle>
            <AlertDialogDescription>
              This action cannot be undone. This will permanently delete this draft campaign.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
            <AlertDialogAction 
              onClick={() => handleDeleteDraft(selectedDraftId)}
              disabled={isDeleting}
              className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            >
              {isDeleting ? "Deleting..." : "Delete"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
